// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSupplier_navbar__uHP7t","logo":"NavbarSupplier_logo__rv6P3","navLinks":"NavbarSupplier_navLinks__KJaS0","navItem":"NavbarSupplier_navItem__LopyB"};